<template>
  <div class="h5-header">
    <div :class="`mNav ${$store.state.h5HeaderClassName}`" id="mNav">
      <div class="mLogo">
        <a href="/" data-count="移动端-顶部导航_首页" class="logo">
          <img :src="require('@/assets/images/logo.png')" class="logo-blue" />
          <img
            :src="require('@/assets/images/logo_white.png')"
            class="logo-white"
          />
        </a>
      </div>
      <div class="mTopLogOrReg" @click="() => toggleSlider('open')">
        <i class="sliderBtn iconfont icondaohang"></i>
      </div>
    </div>
    <div :class="`outerSlider ${sliderIsShow}`">
      <div class="menuBox">
        <div class="sideHeader">
          <img
            class="closeSide"
            @click="() => toggleSlider('')"
            :src="require('@/assets/images/icon_close.png')"
            alt=""
          />
          <a class="sideLogo" href="/">
            <img :src="require('@/assets/images/logo.png')" />
          </a>
        </div>
        <div class="scrollList">
          <ul class="mobileNavSlider">
            <li
              v-for="item in menuData"
              :key="item.id"
              :class="item.children ? '' : 'sideSecondBox'"
            >
              <template v-if="item.children">
                <div class="sideSecondTitle">
                  <span>{{ item.title }}</span>
                  <i
                    :class="`arraw iconfont iconicon_nav_downArrow ${
                      item.isOpen && 'active'
                    }`"
                    @click="() => toggleMenuOpen(item.id)"
                  ></i>
                </div>
                <dl :class="`sideSecondList ${item.isOpen ? '' : 'close'}`">
                  <template v-for="sItem in item.children">
                    <template v-if="sItem.children">
                      <dt class="sideSecondList-title" :key="sItem.id">
                        {{ sItem.title }}
                      </dt>
                      <dd v-for="ssItem in sItem.children" :key="ssItem.id">
                        <router-link
                          :to="ssItem.link"
                          class="more-item"
                          @click.native="toggleSlider('')"
                          >{{ ssItem.title }}</router-link
                        >
                      </dd>
                    </template>
                    <template v-else>
                      <dd :key="sItem.id">
                        <router-link
                          :to="sItem.link"
                          class="more-item"
                          @click.native="toggleSlider('')"
                          >{{ sItem.title }}</router-link
                        >
                      </dd>
                    </template>
                  </template>
                </dl>
              </template>
              <template v-else>
                <router-link
                  :to="item.link"
                  class="more-item"
                  @click.native="toggleSlider('')"
                  >{{ item.title }}</router-link
                >
              </template>
            </li>
          </ul>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { menu } from '@/data.js';
export default {
  data() {
    return {
      sliderIsShow: '',
      menuData: menu
    };
  },
  methods: {
    toggleSlider(name) {
      this.sliderIsShow = name;
    },
    toggleMenuOpen(id) {
      const mapMenu = (arr) => {
        let result = [];
        arr.map(item => {
          if (item.id === id) {
            item.isOpen = !item.isOpen;
          } else {
            if (item.children) {
              item.children = mapMenu(item.children);
            }
          }
          result.push(item);
        });
        return result;
      };
      this.menuData = mapMenu(this.menuData);
    }
  }
};
</script>

<style lang="scss" scoped>
.h5-header {
  .mNav {
    position: fixed;
    left: 0;
    height: 1.04rem;
    box-sizing: border-box;
    align-items: center;
    justify-content: space-between;
    display: flex;
    width: 100%;
    padding: 0.24rem 0.2rem;
    background: #fff;
    top: 0;
    z-index: 8;
    .mLogo {
      width: 1.68rem;
      display: block;
      img {
        width: 100%;
      }
    }
    .mTopLogOrReg {
      align-items: center;
      justify-content: space-between;
      display: flex;
    }
    .sliderBtn {
      font-size: 0.52rem;
      color: #999;
    }
  }
  .logo-white,
  .mNav-transparent .logo-blue {
    display: none;
  }
  .mNav-transparent {
    background: 0 0;
    .logo-white {
      display: block;
    }
    .sliderBtn {
      color: #fff;
    }
  }
  .outerSlider {
    position: fixed;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    top: 0;
    z-index: 9999;
    height: 0;
    transition: all 0.35s;
    overflow: hidden;
    &.open {
      height: 100%;
      transition: all 0.35s;
    }
    .menuBox {
      position: absolute;
      width: 100%;
      background: #fff;
      height: 100%;
      top: 0;
      transition: bottom 0.3s ease-in-out;
    }
    .sideHeader {
      display: block;
      padding: 0.24rem 0.3rem;
      position: relative;
      border-bottom: 1px solid #eee;
      .closeSide {
        width: 0.3rem;
        margin: 0.1rem 0;
        color: #353535;
        float: right;
        cursor: pointer;
      }
      .sideLogo,
      .sideLogo img {
        display: block;
        width: 1.68rem;
      }
    }
    .scrollList {
      height: 100%;
      padding-bottom: 2rem;
      overflow-y: scroll;
      .mobileNavSlider {
        padding: 0 0.32rem;
        & > li {
          border-bottom: 1px solid #e6e6e6;
        }
        li {
          text-align: left;
          line-height: 0.48rem;
          padding: 0.25rem 0;
          a {
            font-size: 0.32rem;
            color: #333;
          }
        }
      }
      .sideSecondTitle {
        position: relative;
        padding-right: 0.32rem;
        font-size: 0.32rem;
        color: #333;
        .arraw {
          border: none;
          font-size: 0.16rem;
          position: absolute;
          right: 0;
          transition: all 0.1s;
          &.active {
            transform: rotate(-180deg);
          }
        }
      }
      .comBtn,
      .comBtnbest {
        width: 5.44rem;
        border-radius: 0.45rem;
        text-align: center;
        display: block;
        font-size: 0.29rem;
      }
      .comBtnbest {
        height: 0.8rem;
        line-height: 0.8rem;
        margin: 1.12rem auto;
      }
      .loginMLink {
        color: #1472ff;
        border: 1px solid #979797;
      }
      .sideSecondList {
        padding: 0.28rem 0 0.06rem;
        &.close {
          height: 0;
          overflow: hidden;
          padding: 0;
        }
        .sideSecondList-title {
          padding-bottom: 0.08rem;
          font-size: 0.24rem;
          color: #999;
        }
        dd {
          display: inline-block;
          margin-bottom: 0.3rem;
          width: 48%;
          a {
            text-align: left;
            font-size: 0.28rem;
            color: #666;
          }
        }
      }
    }
  }
}
</style>
